module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"placeholder":{"postal":"1234 AB","number":"121A","street":"Straatnaam","city":"Amsterdam"}}}')
  delete Component.options._Ctor
}
